import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const AllergyForm = (props) => {

    const [validated, setValidated] = useState(false);
    const initialFormData = {
        allergy: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);
    //const navigate = useNavigate();

    useEffect(() => {
        if (props.allergyvalue && props.allergyvalue.allergy_id) {
            const { allergy, is_active, allergy_id } = props.allergyvalue;
            setFormData({
                allergy: allergy || "",
                isactive: is_active == 1 || is_active === true,
                id: allergy_id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.allergyvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsAllergyUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/patients/add-patient-allergy` :
            `${process.env.REACT_APP_SERVER_URL}/patients/update-patient-allergy`;

        let pelmedsAllergyData = isAddMode ? 
            { "allergy": formData.allergy, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "allergy": formData.allergy, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsAllergyUrl, pelmedsAllergyData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Allergies added/updated successfully");
        }
        else {
            toast.info("Error while adding Allergies");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Allergy</Form.Label>
                        <Form.Control
                            placeholder='Allergy'
                            value={formData.allergy}
                            name="allergy"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-50 mt-4"
                            disabled={!formData.allergy}
                            size="sm"
                        >
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default AllergyForm;

